import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LoadingState, EmptyState } from "@/components/shared";
import { FullProfile } from "@/components/FullProfile";
import { CheckCircle2, XCircle, FileUser, ListChecks } from "lucide-react";

export function AnswersTab({ c }) {
  const rows = c.question_breakdown || [];
  if (!rows.length) return <div className="app-container py-8"><EmptyState icon={ListChecks} title="No answers yet" description="Answers and per-question scoring appear once the candidate submits the assessment." /></div>;
  return (
    <div className="app-container py-6 space-y-4" data-testid="ci-breakdown">
      <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
        {c.objective_score != null && <span>Objective <strong className="text-foreground">{c.objective_score}%</strong></span>}
        {c.subjective_score != null && <span>Situational <strong className="text-foreground">{c.subjective_score}%</strong></span>}
      </div>
      <div className="hs-card divide-y divide-border">
        {rows.map((b, i) => (
          <div key={i} className="px-5 py-4 space-y-2" data-testid={`breakdown-row-${i}`}>
            <div className="flex items-start gap-3">
              <span className="hs-mono text-xs text-muted-foreground mt-0.5 shrink-0 w-7">Q{i + 1}</span>
              <p className="text-sm font-medium flex-1">{b.prompt}</p>
              {b.format === "multiple_choice"
                ? (b.is_correct ? <span className="inline-flex items-center gap-1 text-xs text-primary shrink-0"><CheckCircle2 className="h-3.5 w-3.5" /> Correct</span> : <span className="inline-flex items-center gap-1 text-xs text-rose-500 shrink-0"><XCircle className="h-3.5 w-3.5" /> Incorrect</span>)
                : b.score != null && <span className="hs-mono text-xs shrink-0">{b.score}/100</span>}
            </div>
            <div className="pl-10 text-[13px] space-y-1">
              <p className="text-muted-foreground"><span className="text-foreground/60">Answer:</span> {b.answer ? <span className="text-foreground/90 whitespace-pre-wrap">{b.answer}</span> : <em>— blank —</em>}</p>
              {b.format === "multiple_choice" && !b.is_correct && b.correct_answer && <p className="text-primary/90"><span className="text-foreground/60">Correct:</span> {b.correct_answer}</p>}
              {b.note && <p className="text-muted-foreground italic">{b.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function CvTab({ candId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/candidates/${candId}/profile`).then((r) => setData(r.data)).catch(() => setErr(true)); }, [candId]);
  if (err) return <div className="app-container py-8"><EmptyState icon={FileUser} title="No CV profile" description="This candidate applied without a structured CV profile." /></div>;
  if (!data) return <LoadingState label="Loading CV profile…" />;
  return <div className="app-container py-6 max-w-4xl" data-testid="ci-cv"><div className="hs-card p-6"><FullProfile profile={data.profile || {}} /></div></div>;
}
